import { createGlobalStyle } from 'styled-components';
 
const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    background: #1DD760;
    font-family: Open-Sans, Nunito Sans, Sans-Serif;
  }
`;
 
export default GlobalStyle;
